module.exports = __webpack_public_path__ + "static/filterIcon-83350e66c43a72d12cfd31a7c323035d.png";